module.exports = __webpack_public_path__ + "7d91cb0f132177a2bd260a32c8ececcd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/makeup.png
// module id = 2553
// module chunks = 0